import { languageGlobal } from "./GlobalVariableConfig";

export const getManifest = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    {
                        alias: 'volatilityBase',
                        src: 'assets/2_intro/volatility_base.webp',
                    },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/2_intro/volatility_on.webp',
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/2_intro/volatility_off.webp',
                    },
                    {
                        alias: 'intro_bg',
                        src: 'assets/2_intro/introduction_bg.webp',
                    },
                    {
                        alias: 'textBase',
                        src: 'assets/2_intro/ticket_base.webp',
                    },
                    {
                        alias: 'introLogoStatic',
                        src: 'assets/1_loading/logo.webp',
                    },
                    {
                        alias: 'introLogoSkel',
                        src: 'assets/2_intro/ticket_logo.skel',
                    },
                    {
                        alias: 'introLogoAtlas',
                        src: 'assets/2_intro/ticket_logo.atlas',
                    },
                    // text_base_smoke
                    // {
                    //     alias: 'textBaseSmoke',
                    //     src: 'assets/intro/text_base_smoke.webp',
                    // },
                    {
                        alias: 'image1',
                        src: 'assets/2_intro/image_1.png',
                    },
                    {
                        alias: 'image2',
                        src: 'assets/2_intro/image_2.png',
                    },
                    {
                        alias: 'image3',
                        src: 'assets/2_intro/image_3.png',
                    },
                    {
                        alias: 'continueBase',
                        src: 'assets/2_intro/click_to_continue_base.webp',
                    },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/13_sounds/gameloading/Intro_appear.mp3',
                    // },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/9_bigwin/es/wins.skel' : 'assets/9_bigwin/wins.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/9_bigwin/es/wins.atlas' : 'assets/9_bigwin/wins.atlas',
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    // {
                    //     alias: 'background',
                    //     src: 'assets/base/basegame.webp',
                    // },
                    {
                        alias: 'backgroundFree',
                        src: 'assets/base/freegame.webp',
                    },
                    {
                        alias: 'reelBackFree',
                        src: 'assets/11_reelframe/reelBackFree.webp',
                    },
                    {
                        alias: 'reelBackBase',
                        src: 'assets/11_reelframe/reelBackBase.webp',
                    },
                    {
                        alias: 'reelFrameFgSkel',
                        src: 'assets/11_reelframe/freegame_reel/freegame_reel.skel',
                    },
                    {
                        alias: 'reelFrameFgAtlas',
                        src: 'assets/11_reelframe/freegame_reel/freegame_reel.atlas',
                    },
                    {
                        alias: 'logoBaseBasegame',
                        src: 'assets/base/reel/basegame_logo_base.webp',
                    },
                    {
                        alias: 'logoBaseFreegame',
                        src: 'assets/base/reel/freegame_logo_base.webp',
                    },
                    {
                        alias: 'opa_winPatch',
                        src: 'assets/11_reelframe/opa_winPatch.png',
                    },
                    // character animation *********************
                    {
                        alias: 'characterSkel',
                        src: 'assets/5_character/mascort.skel',
                    },
                    {
                        alias: 'characterAtlas',
                        src: 'assets/5_character/mascort.atlas',
                    },
                    // Game Intro animation *********************
                    {
                        alias: 'gameIntroSkel',
                        src: 'assets/3_gameintro/game_intro.skel',
                    },
                    {
                        alias: 'gameIntroAtlas',
                        src: 'assets/3_gameintro/game_intro.atlas',
                    },
                    //logo *********************
                    {
                        alias: 'logoStatic',
                        src: 'assets/4_logo/logoStatic.webp',
                    },
                    //highlight *********************
                    {
                        alias: 'highlightFrame',
                        src: 'assets/base/highlite_frame.webp',
                    },
                    // //logo animation *********************
                    {
                        alias: 'frameSkel',
                        src: 'assets/base/spot_frame/spot_frame.skel',
                    },
                    {
                        alias: 'frameAtlas',
                        src: 'assets/base/spot_frame/spot_frame.atlas',
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/4_logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/4_logo/logo.atlas',
                    },
                    // transition
                    {
                        alias: 'transitionSkel',
                        src: 'assets/base/transition/transition.skel',
                    },
                    {
                        alias: 'transitionAtlas',
                        src: 'assets/base/transition/transition.atlas',
                    },
                    // multiplier meter fx *********************
                    {
                        alias: 'multiplerMeterFxSkel',
                        src: 'assets/base/multiplier_meter_fx/multiplier.skel',
                    },
                    {
                        alias: 'multiplerMeterFxAtlas',
                        src: 'assets/base/multiplier_meter_fx/multiplier.atlas',
                    },

                    // exp wild fx *********************
                    {
                        alias: 'expWildFxSkel',
                        src: 'assets/base/expanding_wild_fx/expanding_fx.skel',
                    },
                    {
                        alias: 'expWildFxAtlas',
                        src: 'assets/base/expanding_wild_fx/expanding_fx.atlas',
                    },
                    //banner *********************
                    // {
                    //     alias: 'banner',
                    //     src: 'assets/banner/intro_outro_base.webp',
                    // },
                    //banner-spine
                    {
                        alias: 'freegame_intro_bg',
                        src: 'assets/7_banner/intro_outro_bg.webp',
                    },
                    //banner-left-char
                    {
                        alias: 'bannerBaseSkel',
                        src: 'assets/7_banner/intro_outro.skel',
                    },
                    {
                        alias: 'bannerBaseAtlas',
                        src: 'assets/7_banner/intro_outro.atlas',
                    },
                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/6_basegame/background/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/6_basegame/background/basegame.atlas',
                    },
                    //free game background animation
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/8_freegame/background/freegame.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/8_freegame/background/freegame.atlas',
                    },
                    // multiplier effect
                    {
                        alias: 'multiplierBlastSkel',
                        src: 'assets/base/multiplier_blast/multiplier_blast.skel',
                    },
                    {
                        alias: 'multiplierBlastAtlas',
                        src: 'assets/base/multiplier_blast/multiplier_blast.atlas',
                    },
                    //amount effect
                    {
                        alias: 'amountEffectSkel',
                        src: 'assets/base/amount_effect/amount_effect.skel',
                    },
                    {
                        alias: 'amountEffectAtlas',
                        src: 'assets/base/amount_effect/amount_effect.atlas',
                    },
                    //particle effect
                    {
                        alias: 'particleEffectSkel',
                        src: 'assets/particle_effect/particle_effect.skel',
                    },
                    {
                        alias: 'particleEffectAtlas',
                        src: 'assets/particle_effect/particle_effect.atlas',
                    },
                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/12_symbols/hv1/hv_1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/12_symbols/hv1/hv_1.atlas',
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/12_symbols/hv2/hv_2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/12_symbols/hv2/hv_2.atlas',
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/12_symbols/hv3/hv_3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/12_symbols/hv3/hv_3.atlas',
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/12_symbols/hv4/hv_4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/12_symbols/hv4/hv_4.atlas',
                    },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/12_symbols/lv1/lv_1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/12_symbols/lv1/lv_1.atlas',
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/12_symbols/lv2/lv_2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/12_symbols/lv2/lv_2.atlas',
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/12_symbols/lv3/lv_3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/12_symbols/lv3/lv_3.atlas',
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/12_symbols/lv4/lv_4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/12_symbols/lv4/lv_4.atlas',
                    },
                    //lv5
                    {
                        alias: 'lv5Skel',
                        src: 'assets/12_symbols/lv5/lv_5.skel',
                    },
                    {
                        alias: 'lv5Atlas',
                        src: 'assets/12_symbols/lv5/lv_5.atlas',
                    },
                    //lv6
                    {
                        alias: 'lv6Skel',
                        src: 'assets/12_symbols/lv6/lv_6.skel',
                    },
                    {
                        alias: 'lv6Atlas',
                        src: 'assets/12_symbols/lv6/lv_6.atlas',
                    },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/12_symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/12_symbols/scatter/scatter.atlas',
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/12_symbols/wild/wild.atlas',
                    },
                    //shutter
                    {
                        alias: 'shutterSkel',
                        src: 'assets/12_symbols/shutter/shutter.skel',
                    },
                    {
                        alias: 'shutterAtlas',
                        src: 'assets/12_symbols/shutter/shutter.atlas',
                    },
                    //windmill
                    {
                        alias: 'windmillSkel',
                        src: 'assets/12_symbols/windmill/windmill.skel',
                    },
                    {
                        alias: 'windmillAtlas',
                        src: 'assets/12_symbols/windmill/windmill.atlas',
                    },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/12_symbols/wild/wild.atlas',
                    },
                    //win_digit_export
                    {
                        alias: 'win_digit_export',
                        src: 'assets/10_fonts/win_export/digit_export.xml',
                    },
                    //symbol_multiplier
                    {
                        alias: 'symbol_multiplier',
                        src: 'assets/10_fonts/symbol_multiplier/symbol_multiplier.xml',
                    },
                    //PenguineRoyale_ttf
                    {
                        alias: 'Germania',
                        src: 'assets/10_fonts/penguine_germania/GermaniaOne.ttf',
                    },
                    //multiplier- font
                    {
                        alias: 'penguine_multiplier',
                        src: 'assets/10_fonts/penguine_reel_multiplier/penguine_multiplier.xml',
                    },
                    {
                        alias: 'penguine_reel_multiplier',
                        src: 'assets/10_fonts/penguine_reel_multiplier/penguine_reel_multiplier.xml',
                    },
                    {
                        alias: 'penguine_banner_multiplier',
                        src: 'assets/10_fonts/penguine_reel_multiplier/banner_multiplier/banner_multiplier.xml',
                    },
                    // OPA! Fonts
                    {
                        alias: 'norse',
                        src: 'assets/10_fonts/Norsebold.otf',
                    },
                    {
                        alias: 'adonais',
                        src: 'assets/10_fonts/Adonais.ttf',
                    },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/13_sounds/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/13_sounds/ui/btn_spin.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        // src: 'assets/13_sounds/flf_mx_basegame.mp3',
                        src: 'assets/13_sounds/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/13_sounds/base/Bg_loop.mp3',
                    },
                    {
                        alias: 'man_jump',
                        src: 'assets/13_sounds/gameloading/man_jump.mp3',
                    },
                    {
                        alias: 'scene_expansion',
                        src: 'assets/13_sounds/gameloading/scene_expansion.mp3',
                    },
                    {
                        alias: 'wall_crack',
                        src: 'assets/13_sounds/gameloading/wall_crack.mp3',
                    },
                    {
                        alias: 'Intro_transition',
                        src: 'assets/13_sounds/gameloading/Intro_transition.mp3',
                    },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/13_sounds/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'free_Game_Banner',
                        src: 'assets/13_sounds/freegame/free_Game_Banner.mp3',
                    },
                    {
                        alias: 'total_win',
                        src: 'assets/13_sounds/freegame/total_win.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/13_sounds/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'fsSpin_awarded',
                        src: 'assets/13_sounds/freegame/additional_fspins.mp3',
                    },
                    {
                        alias: 'reel_stop',
                        src: 'assets/13_sounds/spin/reel_stop.mp3',
                    },
                    {
                        alias: 'scatter_stop',
                        src: 'assets/13_sounds/spin/scatter_landing.mp3',
                    },
                    {
                        alias: 'multiplier_collect',
                        src: 'assets/13_sounds/spin/multiplier_collect.mp3',
                    },
                    {
                        alias: 'reel_greenlight_anticipation',
                        src: 'assets/13_sounds/spin/reel_greenlight_anticipation.mp3',
                    },
                    {
                        alias: 'symbol_transform_to_wild',
                        src: 'assets/13_sounds/spin/symbol_transform_to_wild.mp3',
                    },
                    {
                        alias: 'wild_symbol_shooting_bluemagic',
                        src: 'assets/13_sounds/spin/wild_symbol_shooting_bluemagic.mp3',
                    },
                    {
                        alias: 'man_anim_sword_pointing_up',
                        src: 'assets/13_sounds/spin/man_anim_sword_pointing_up.mp3',
                    },
                    {
                        alias: 'man_anim_sword_to_hand',
                        src: 'assets/13_sounds/spin/man_anim_sword_to_hand.mp3',
                    },
                    {
                        alias: 'man_anim_when_bonus_trg',
                        src: 'assets/13_sounds/spin/man_anim_when_bonus_trg.mp3',
                    },
                    {
                        alias: 'symbol_win',
                        src: 'assets/13_sounds/win/common_win.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/13_sounds/win/higher_win.mp3',
                    },
                    {
                        alias: 'symbol_cascade',
                        src: 'assets/13_sounds/win/symbol_explosion.mp3',
                    },
                    // {
                    //     alias: 'higher_win',
                    //     src: 'assets/13_sounds/win/higher_win.mp3',
                    // },
                    {
                        alias: 'win_loop',
                        src: 'assets/13_sounds/bigwin/Win_Loop.mp3',
                    },

                    {
                        alias: 'Big_Win_Transition',
                        src: 'assets/13_sounds/bigwin/Big_Win_Transition.mp3',
                    },
                    {
                        alias: 'Mega_Win_Transition',
                        src: 'assets/13_sounds/bigwin/Mega_Win_Transition.mp3',
                    },
                    {
                        alias: 'Super_Win_Transition',
                        src: 'assets/13_sounds/bigwin/Super_Win_Transition.mp3',
                    },
                    {
                        alias: 'Epic_Win_Transition',
                        src: 'assets/13_sounds/bigwin/Epic_Win_Transition.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/13_sounds/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/13_sounds/bigwin/Win_Count_up_End.mp3',
                    },
                    {
                        alias: 'ending_transition',
                        src: 'assets/13_sounds/bigwin/ending_transition.mp3',
                    },
                    //Character sounds
                    {
                        alias: 'glass_sip', //Laughing
                        src: 'assets/13_sounds/character/animation1.mp3',
                    },
                    // {
                    //     alias: 'slam_the_ground', //action_2
                    //     src: 'assets/13_sounds/character/slam_the_ground.mp3',
                    // },
                    // {
                    //     alias: 'jump',  // jump
                    //     src: 'assets/13_sounds/character/jump.mp3',
                    // },
                    // {
                    //     alias: 'low_hand_raise',
                    //     src: 'assets/13_sounds/character/low_hand_raise.mp3', //idle_3
                    // },
                    // {
                    //     alias: 'full_sword_up',
                    //     src: 'assets/13_sounds/character/full_sword_up.mp3',
                    // },
                    // {
                    //     alias: 'back_scratching',
                    //     src: 'assets/13_sounds/character/back_scratching.mp3',
                    // },
                    //multiplier sounds
                    {
                        alias: 'multiplier_panel',
                        src: 'assets/13_sounds/win/multiplier_panel.mp3',
                    },
                    {
                        alias: 'multiplier_move',
                        src: 'assets/13_sounds/win/multiplier_move.mp3',
                    },
                    // Wild Appear
                    {
                        alias: 'wild_appear',
                        src: 'assets/13_sounds/win/wild_appear.mp3',
                    },
                    //Feature related
                    {
                        alias: 'multiplier_on_plates',
                        src: 'assets/13_sounds/feature/multiplier_landing_plates.mp3',
                    },
                    {
                        alias: 'multiplier_on_shutter',
                        src: 'assets/13_sounds/feature/multiplier_landing_window.mp3',
                    },
                    {
                        alias: 'windmill_trigger',
                        src: 'assets/13_sounds/feature/windmill_highlight.mp3',
                    },
                    {
                        alias: 'windmill_spread',
                        src: 'assets/13_sounds/feature/windmill_cascade.mp3',
                    },
                    {
                        alias: 'windmill_reveal_to_plateandshutter',
                        src: 'assets/13_sounds/feature/windmill_reveal.mp3',
                    },
                    {
                        alias: 'shutter_opening',
                        src: 'assets/13_sounds/feature/window_opening.mp3',
                    },
                    {
                        alias: 'windmill_appear',
                        src: 'assets/13_sounds/feature/windmill_show.mp3',
                    },
                    {
                        alias: 'windmill_reveal_shutter',
                        src: 'assets/13_sounds/feature/windmill_reveal_shutter.mp3',
                    },
                ],
            },

        ],
    }
};

